import React, { useState ,useEffect} from "react";
import * as S from './CabDetailsStyles';
import Terminals from "../Terminals/Terminals";
import OwnerDetails from "../OwnerDetails/OwnerDetails";
import BookingDetails from "../BookingDetails/BookingDetails";
import { API_STATUS, RUNNING_CAR_URL } from "../../../../../config/constants";
import { getHOBDriverData } from "../../../redux/thunks";
import { Strings } from "../../../utils";

const CabDetails = ({
    data,
    isPreDeparture,
    refId,
    bookingId,
    rightImg,
    cityToAirport
}) => {

    const {
        headerSection,
        footerData
    } = data || {};

    const {
        ownerDetails,
        listItems
    } = headerSection || {};

    const [driverApiStatus, setDriverApiStatus] = useState(API_STATUS.INITIAL);
    const [ driverDetails, setDriverDetails ] = useState({});
    
    const driverData =   {
    otpTxt:{
    label1: Strings.label1,
    value: driverDetails?.response?.otp || '',
    label2: Strings.label2
    },
    ownerDetails:{
        name: driverDetails?.response?.driverName || '',
        img: driverDetails?.response?.driverImage || '',
        subLabel: driverDetails?.response?.cabModel || '',
        ratingVal: driverDetails?.response?.rating || ''
    },
    vehicleNo:driverDetails?.response?.vehicleNo || '',
    vehicleImg: driverDetails?.response?.cabImage || '',
    helplineNumberTxt: Strings.helplineNumberTxt,
    driverNumberTxt: Strings.driverNumberTxt,
    footerData:footerData
}

    useEffect(() => {
      if(!isPreDeparture && !cityToAirport){
        let timer;
        let elapsedTime = 0;
        
        const fetchAndSetDriverData = async (request) => {
          const driverResponse = await getHOBDriverData(request);
          setDriverDetails(driverResponse);
          return driverResponse;
        }
      
        const callDriverAPI = async () => {
          try {
            setDriverApiStatus(API_STATUS.LOADING);
      
            const request = {
              bookingId,
              refId,
              type: 'thankYouRequest',
              book_mode: 'M'
            };
            const driverResponse = await fetchAndSetDriverData(request);
            if (driverResponse?.status !== 'SUCCESS' && elapsedTime < 300000) {
              timer = setTimeout(callDriverAPI, 15000);
              elapsedTime += 15000;
            } 
          } catch (e) {
            setDriverApiStatus(API_STATUS.INITIAL);
          }
          setDriverApiStatus(API_STATUS.SUCCESS);
        };
      
        callDriverAPI();
      
        return () => {
          clearTimeout(timer);
        };
      }
    }, []); 

    const topSection = () => (
      <S.TopSection>
        <div className="headerSection">
          <OwnerDetails data={ownerDetails} />
          { listItems && <p className="listItems">
            { listItems?.map((item, idx) => (
              <S.ListItem key={idx} className="listItem">
                  {item}
                  { (idx + 1 < listItems?.length) && <S.BorderRight /> }
              </S.ListItem>
            )) }
          </p> }
        </div>
        {rightImg &&  <S.IconWrapper>
          <S.QuickRideIcon src={rightImg} alt="quickRideIcon" />
        </S.IconWrapper>}
      </S.TopSection>
    );

    const gifSection = () => (
      <S.GifSection>
        <S.RunningCar src={RUNNING_CAR_URL} alt="runningCar" />
        <S.RunningCarText>Fetching driver details...</S.RunningCarText>
      </S.GifSection>
    );

  return (
    <>
      {driverDetails &&
        driverDetails?.status === 'SUCCESS' &&
        driverApiStatus === API_STATUS.SUCCESS &&
        driverDetails.response ? (
          <S.BookingDetailsTransition>
            <BookingDetails
              data={driverData}
              driverNumber={driverDetails?.response?.driverNo}
              helplineNumber={driverDetails?.response?.helplineNo}
              rightImg ={driverDetails?.response?.supplierImage}
            />
          </S.BookingDetailsTransition>
        ) : (
          <S.CabDetail>
            {topSection()}
            {!isPreDeparture && gifSection && gifSection()}
            {!isPreDeparture && <div className="nonKiosk"></div>}
            <Terminals data={footerData} />
          </S.CabDetail>
        )}
    </>
  );
};

export default CabDetails;